var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "custom-field" },
    [
      _vm.renderTextfield(_vm.idCustomFieldType)
        ? [
            _c("label", [_vm._v(_vm._s(_vm.item.label))]),
            _c("input", { attrs: { disabled: "" } }),
            _vm.renderTextfieldIcon(_vm.idCustomFieldType)
              ? _c("span", {
                  class: [_vm.renderedIcon(_vm.idCustomFieldType), "show-icon"],
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.renderTextarea(_vm.idCustomFieldType)
        ? [
            _c("label", [_vm._v(_vm._s(_vm.label))]),
            _c("textarea", { attrs: { disabled: "" } }),
          ]
        : _vm._e(),
      _vm.renderSelect(_vm.idCustomFieldType)
        ? [
            _c("label", [_vm._v(_vm._s(_vm.label))]),
            _c("v-select", {
              staticClass: "select-field",
              attrs: {
                items: _vm.item.listOptions,
                "append-icon": _vm.icons.selectIcon,
                "hide-details": "",
                height: "38",
                attach: "",
                dense: "",
                "menu-props": { offsetY: true },
                outlined: "",
                "item-text": "value",
                clearable: "",
                multiple: Boolean(Number(_vm.item.multipleSelection)),
              },
            }),
          ]
        : _vm._e(),
      _vm.renderSwitch(_vm.idCustomFieldType)
        ? [
            _c("LexonSwitchComponent", {
              staticClass: "switch-field",
              attrs: {
                id: String(_vm.id),
                label: _vm.label,
                name: _vm.id,
                "hide-details": "",
                value: true,
                disabled: "",
              },
            }),
          ]
        : _vm._e(),
      _vm.renderFieldset(_vm.idCustomFieldType)
        ? [
            _c(
              "fieldset",
              [
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.label)),
                ]),
                _c(
                  "transition-group",
                  { attrs: { name: "reorder-transition", tag: "div" } },
                  _vm._l(_vm.fields, function (field, index) {
                    return _c(
                      "div",
                      { key: field.uuid, staticClass: "fieldset-container" },
                      [
                        _vm.renderTextfield(field.idCustomFieldType)
                          ? _c("div", { staticClass: "fieldset-field" }, [
                              _c("label", [_vm._v(_vm._s(field.label))]),
                              _c("input", { attrs: { disabled: "" } }),
                              _vm.renderTextfieldIcon(field.idCustomFieldType)
                                ? _c("span", {
                                    class: [
                                      _vm.renderedIcon(field.idCustomFieldType),
                                      "show-icon",
                                    ],
                                  })
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm.renderTextarea(field.idCustomFieldType)
                          ? _c("div", { staticClass: "fieldset-field" }, [
                              _c("label", [_vm._v(_vm._s(field.label))]),
                              _c("textarea", { attrs: { disabled: "" } }),
                            ])
                          : _vm._e(),
                        _vm.renderSelect(field.idCustomFieldType)
                          ? _c(
                              "div",
                              { staticClass: "fieldset-field" },
                              [
                                _c("label", [_vm._v(_vm._s(field.label))]),
                                _c("v-select", {
                                  staticClass: "select-field",
                                  attrs: {
                                    items: field.listOptions,
                                    "append-icon": _vm.icons.selectIcon,
                                    "hide-details": "",
                                    height: "38",
                                    attach: "",
                                    dense: "",
                                    "menu-props": { offsetY: true },
                                    outlined: "",
                                    "item-text": "value",
                                    clearable: "",
                                    multiple: Boolean(
                                      Number(field.multipleSelection)
                                    ),
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.renderSwitch(field.idCustomFieldType)
                          ? [
                              _c("LexonSwitchComponent", {
                                staticClass: "switch-field",
                                attrs: {
                                  id: String(field.id),
                                  label: field.label,
                                  name: field.id,
                                  "hide-details": "",
                                  value: true,
                                  disabled: "",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _c("CustomFieldActionButtonsComponent", {
                          attrs: {
                            index: index,
                            item: field,
                            fieldsNumber: _vm.fields.length,
                          },
                          on: {
                            "move-up": _vm.moveUp,
                            "move-down": _vm.moveDown,
                            "remove-field": function ($event) {
                              return _vm.removeField(field)
                            },
                            "edit-field": function ($event) {
                              return _vm.editField(field, index)
                            },
                          },
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.renderNumeration(_vm.idCustomFieldType)
        ? [
            _c(
              "transition-group",
              { attrs: { name: "reorder-transition", tag: "div" } },
              _vm._l(_vm.fields, function (field, index) {
                return _c(
                  "div",
                  { key: field.uuid, staticClass: "fieldset-container" },
                  [
                    _vm.renderNumeric(field.idCustomFieldType)
                      ? _c(
                          "div",
                          { staticClass: "fieldset-field" },
                          [
                            _c("LexonNumericComponent", {
                              attrs: {
                                id: field.uuid,
                                placeholder: field.placeholder,
                                disabled: field.disabled,
                              },
                              model: {
                                value: field.value,
                                callback: function ($$v) {
                                  _vm.$set(field, "value", $$v)
                                },
                                expression: "field.value",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.renderTextfieldOnly(field.idCustomFieldType)
                      ? _c(
                          "div",
                          { staticClass: "fieldset-field" },
                          [
                            _c("LexonTextFieldComponent", {
                              attrs: {
                                type: "text",
                                id: field.uuid,
                                placeholder: field.placeholder,
                                disabled: field.disabled,
                                validationRules: field.validationRules,
                              },
                              model: {
                                value: field.value,
                                callback: function ($$v) {
                                  _vm.$set(field, "value", $$v)
                                },
                                expression: "field.value",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.renderSelect(field.idCustomFieldType)
                      ? _c(
                          "div",
                          { staticClass: "fieldset-field" },
                          [
                            _c("LexonAutocompleteComponent", {
                              attrs: {
                                disabled: field.disabled,
                                "prop-items": field.listOptions,
                                placeholder: field.placeholder,
                                clearable: false,
                                "item-name": "name",
                                "item-value": "id",
                                "key-id": "id",
                              },
                              model: {
                                value: field.value,
                                callback: function ($$v) {
                                  _vm.$set(field, "value", $$v)
                                },
                                expression: "field.value",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }